import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UIModule } from '@common/UI/UI.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { UserblockComponent } from './sidebar/userblock/userblock.component';
import { CoreModule } from '@core/core.module';

@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    RouterModule,
    UIModule
    ],
    declarations: [
        LayoutComponent,
        SidebarComponent,
        HeaderComponent,
        FooterComponent,
        UserblockComponent,
    ],
    exports: [
        LayoutComponent,
    ]
})

export class LayoutModule {
}
